import { NgModule, } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AskHrService } from './services/ask-hr.service';
import { FormsModule } from '@angular/forms';
import {
  HelpfulInformationComponent,
  AnswerComponent,
  SendEmailComponent,
  SendToHRComponent,
  RateExperianceComponent,
  NewConversationComponent,
  LoaderComponent,
  UserChoisePromptComponent
 } from '@app/components';
import { AllowOriginInterceptor } from './core/interceptors/allowed-origins.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AvatarModule } from 'primeng/avatar';
import { NgxJiraIssueCollectorModule } from 'ngx-jira-issue-collector';
import { RatingCommunicationService } from './services/rating-communication.service';

@NgModule({
  declarations: [
    AppComponent,
    RateExperianceComponent,
    HelpfulInformationComponent,
    SendEmailComponent,
    AnswerComponent,
    SendToHRComponent,
    NewConversationComponent,
    LoaderComponent,
    UserChoisePromptComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    AvatarModule,
    NgxJiraIssueCollectorModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AllowOriginInterceptor, multi: true }, RatingCommunicationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
